<woo-modal-layout size="medium" (close)="close()">
    <h3 header >Skapa ny rabatt</h3>
    <new-voucher
        (onNewVoucher)="submit.emit($event) "
        (onAbort)="close()"
        [agencies]="agencies() ?? []"
        [adOrganisations]="adOrganisations() ?? []"
    ></new-voucher>
</woo-modal-layout>  
